<template src="./Indexing.html"></template>

<script>
import sitesTopMenu from "@/components/sites/components/topMenu"
import Pagination from "@/components/components/pagination"
import Chart from '@/components/brand/dynamics/components/Chart';
import {createNamespacedHelpers} from 'vuex'
import SelfDateRangePicker from "@/components/components/SelfDataRagePicker"

const {mapGetters, mapActions} = createNamespacedHelpers('sites/indexing')

export default {
  name: "Indexing",
  components: {
    sitesTopMenu,
    Pagination,
    Chart,
    SelfDateRangePicker
  },
  data() {
    return {
      showOverlay: false,
      currentSiteId: this.$route.params.id,
      fieldsList: [
        {
          key: 'datetime',
          label: 'Время',
          sortable: true
        },
        {
          key: 'code',
          label: 'Код',
          sortable: true
        },
        {
          key: 'message',
          label: 'Сообщение',
          sortable: true
        },
        {
          key: 'url',
          label: 'Ссылка',
          sortable: true
        },
      ],

      // chartName: '',
      sortBy: 'request',
      sortDesc: true,
      // activeQueryId: null,
      chartCountry: '',
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      },
      dateRange: {
        startDate: null,
        endDate: null,
      },
      getRange: null,
      file: null,
      isLoad: false,
      indexingStatus: null,
      updatePeriod: 180,
      updatePeriodTimerKey: null,
    }
  },
  methods: {
    ...mapActions([
      'GET_ERROR',
      'GET_HISTORY',
      'UPLOAD_FILE',
      'SWITCH_STATUS',
      'GET_INDEXING_STATUS',
      'FILE_DELETE',
      'CHANGE_UPDATE_PERIOD',
    ]),
    sortingChanged: function (ctx) {
      this.$store.commit('sites/indexing/SORT_FIELD', ctx.sortBy)
      this.$store.commit('sites/indexing/SORT_DIR', ctx.sortDesc ? 'desc' : 'asc')
      this.GET_ERROR({th: this})
    },
    perPage: function (page) {
      this.$store.commit('sites/indexing/PER_PAGE', page)
      this.GET_ERROR({th: this})
    },
    goToPage: function (page) {
      this.$store.commit('sites/indexing/CURRENT_PAGE', page)
      this.GET_ERROR({th: this})
    },
    getChartDat: function () {
      if (this.FROM != null && this.TO != null) {
        this.GET_HISTORY({th: this});
      }
    },
    updateRangePicker: function (val) {
      this.$store.commit('sites/indexing/FROM', val.from);
      this.$store.commit('sites/indexing/TO', val.to);
      this.getChartDat()
    },
    loadFile: function () {
      if (this.file == null) {
        return;
      }
      let formData = new FormData();
      formData.append('file', this.file);

      this.isLoad = true
      this.UPLOAD_FILE({th: this, formData: formData})
    },
    indexingStatusChange: function () {
      this.$store.commit('sites/indexing/INDEXING_STATUS', !this.indexingStatus);
      this.SWITCH_STATUS({th: this})
    },
    deleteGoogleFile: function () {
      this.FILE_DELETE({th: this})
    },
    changeUpdatePeriod: function () {
      this.$store.commit('sites/indexing/UPDATE_PERIOD', this.updatePeriod);
      // delete timeout if exist
      if (this.updatePeriodTimerKey != null) {
        clearTimeout(this.updatePeriodTimerKey)
      }
      // send via timeout
      this.updatePeriodTimerKey = setTimeout(() => {
        this.CHANGE_UPDATE_PERIOD({th: this})
        this.updatePeriodTimerKey = null
      }, 3000)
    }
  },
  computed: {
    ...mapGetters([
      'DOMAIN',
      'ERROR_DATA',
      'INDEXING_HISTORY',
      'CURRENT_SITE_ID',
      'FROM',
      'TO',
      'AMOUNT_PAGE',
      'PER_PAGE',
      'TOTAL_ROWS',
      'CURRENT_PAGE',
      'SORT_DIR',
      'SORT_FIELD',
      'INDEXING_TOTAL',
      'INDEXING_STATUS',
      'IS_GOOGLE_KEY_UPLOADED',
      'UPDATE_PERIOD',
    ]),
    chartStyles() {
      return {
        height: '700px',
        position: 'relative'
      }
    },
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('sites') === -1) {
      this.$router.push({name: 'permissionDenied'})
      return
    }

    if (this.INDEXING_STATUS == null) {
      this.GET_INDEXING_STATUS({th: this});
    }

    if (this.ERROR_DATA.length == 0) {
      this.GET_ERROR({th: this});
    }

    if (this.INDEXING_HISTORY.labels === undefined) {
      this.getChartDat()
    }
  },
  created() {

    if (this.CURRENT_SITE_ID != null && this.CURRENT_SITE_ID == this.currentSiteId) {
      this.updatePeriod = this.UPDATE_PERIOD
      this.indexingStatus = this.INDEXING_STATUS
    } else {
      this.indexingStatus = null
      this.$store.commit('sites/indexing/IS_GOOGLE_KEY_UPLOADED', false)
      this.$store.commit('sites/indexing/INDEXING_STATUS', null)
      this.$store.commit('sites/indexing/ERROR_DATA', [])
      this.$store.commit('sites/indexing/INDEXING_HISTORY', {})
    }

    this.$store.commit('sites/indexing/CURRENT_SITE_ID', this.currentSiteId)

    this.dateRange.startDate = this.monthAgo
    this.dateRange.endDate = this.today

    this.$store.commit('sites/indexing/FROM', this.dateToString(this.monthAgo))
    this.$store.commit('sites/indexing/TO', this.dateToString(this.today))

    this.$store.commit('sites/indexing/PER_PAGE', this.initPageSize());
  }
}
</script>

<style scoped>
.search-box {
  width: 375px;
  float: left
}

.total-search-box {
  width: 525px;
}

.query-link {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
  cursor: pointer;
}

.query-link:hover {
  text-decoration: underline;
}

.chart-col {
  position: fixed;
  width: 500px;
  margin: auto;
}

.chart-box {
  width: 1700px;
  display: block;
}

.picker-box {
  display: block;
  text-align: left;
  padding-left: 65px;
}

.text-align-left {
  text-align: left;
}
.cursive {
  font-style: italic;
}
</style>

<style>

</style>